import React from 'react';
import { Stars } from './Stars';
import { topTestimonials } from '../data/content';
export function TopTestimonials() {
  return <section aria-label="Coach testimonials" className="bg-slate-100 px-5 py-14 sm:py-16" data-id="element-208" data-mp="1pdhrf9o51wlf">
      <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-209" data-mp="1agha803kpk17">
        {topTestimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-xl border-t-4 border-gold bg-white p-6 shadow-sm" data-id="element-210" data-mp="1fhww1udkrukn">
            <Stars data-id="element-211" data-mp="16fdy9oonc859" />
            <blockquote className="mt-4 text-[15px] leading-relaxed text-slate-700" data-id="element-212" data-mp="16goxrcb26tqk">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-5" data-id="element-213" data-mp="roeself73xpd">
              <p className="font-display text-sm font-bold text-navy-800" data-id="element-214" data-mp="wq42nyulg7ce">
                {t.name}
              </p>
              <p className="text-xs text-slate-500" data-id="element-215" data-mp="iq2zgcquwntr">{t.location}</p>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}